import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import {BrowserRouter} from 'react-router-dom'
import {DataContextProvider} from './context/DataContext.jsx'
import './frontend/assets/js/phoenix.js'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <DataContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>    
    </DataContextProvider>
  </React.StrictMode>,
)
